import { TextField } from "@mui/material";
import MDBox from "components/MDBox";

export const FiscalWeekOption = ({fiscalWeek, weekChangeHandler, id = "fiscal_week"}) => {
  return (
    <MDBox>
      <TextField
        type="number"
        label="Fiscal Week"
        id={id}
        helperText="*Required"
        value={fiscalWeek}
        onChange={weekChangeHandler}
      ></TextField>
    </MDBox>
  );
};
